<template>
    <div class="action-codes">

        <div class="codes-header">
            <div>
                <h5 class="codes-title">
                    {{ __t ? __t('PROMO_CODES') : 'PROMO_CODES' }}
                </h5>

                <div class="codes-subtitle">
                    {{ __t('P.TOTAL') }}: <strong>{{ totalCodes }}</strong>,
                    {{ __t('P.NEW') }}: <strong>{{ newCodes }}</strong>,
                    {{ __t('P.USED') }}: <strong>{{ finishedCodes }}</strong>
                </div>
            </div>
        </div>

        <div v-if="promoCodes.length > 0" class="table-responsive codes-table-wrap">
            <table class="table table-sm codes-table mb-0">
                <thead>
                <tr>
                    <th class="col-num">#</th>
                    <th> {{  __t('PROMO_CODES') }}</th>
                    <th class="col-status">{{  __t('PROMO_STATE') }}</th>
                    <th class="col-date">{{  __t('P.USED') }}</th>
                </tr>
                </thead>

                <tbody>
                <tr
                    v-for="(item, index) in promoCodes"
                    :key="`${item.code}_${index}`"
                    :class="getRowClass(item)"
                >
                    <td class="text-muted">
                        {{ index + 1 }}
                    </td>

                    <td>
                        <span class="promo-code-text">
                            {{ item.code }}
                        </span>
                    </td>

                    <td>
                        <span class="badge status-badge" :class="getStatusClass(item.status)">
                            {{ getStatusText(item.status) }}
                        </span>
                    </td>

                    <td class="text-muted">
                        {{ getAddedDate(item) }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div v-else class="empty-codes">
            Промокодів поки немає. Завантажте файл на вкладці Основні.
        </div>

    </div>
</template>

<script>
export default {
    name: "action_codes",

    props: {
        action: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    computed: {
        promoCodes() {
            return this.action?.promo_codes || [];
        },

        totalCodes() {
            return this.promoCodes.length;
        },

        finishedCodes() {
            return this.promoCodes.filter(item => item.status === 'finish').length;
        },

        newCodes() {
            return this.promoCodes.filter(item => item.status === 'new').length;
        }
    },

    methods: {
        getStatusText(status) {
            if (status === 'finish') {
                return 'Використано';
            }

            if (status === 'new') {
                return 'Новий';
            }

            return status || '-';
        },

        getStatusClass(status) {
            if (status === 'finish') {
                return 'badge-success';
            }

            if (status === 'new') {
                return 'badge-light';
            }

            return 'badge-secondary';
        },

        getRowClass(item) {
            if (item.status === 'finish') {
                return 'promo-code-row-finish';
            }

            return '';
        },

        getAddedDate(item) {
            return item.added || item.created_at || '-';
        }
    }
}
</script>



<style scoped>
.action-codes {
    padding: 18px 20px 24px;
}

.codes-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
}

.codes-title {
    margin: 0 0 4px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: .02em;
}

.codes-subtitle {
    font-size: 12px;
    color: #7a8491;
}

.codes-table-wrap {
    border: 1px solid #e5e9ef;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
}

.codes-table {
    font-size: 13px;
}

.codes-table thead th {
    background: #f8f9fb;
    border-bottom: 1px solid #e5e9ef;
    color: #4b5563;
    font-weight: 600;
    padding: 9px 10px;
}

.codes-table tbody td {
    padding: 9px 10px;
    vertical-align: middle;
    border-top: 1px solid #edf0f4;
}

.codes-table tbody tr:hover {
    background: #f9fafb;
}

.col-num {
    width: 55px;
}

.col-status {
    width: 150px;
}

.col-date {
    width: 190px;
}

.promo-code-text {
    font-family: monospace;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: .03em;
}

.status-badge {
    padding: 5px 8px;
    font-size: 11px;
    font-weight: 600;
}

.promo-code-row-finish {
    background: #e9f8ef;
}

.promo-code-row-finish td {
    background: #e9f8ef;
}

.empty-codes {
    border: 1px dashed #d9dee7;
    border-radius: 6px;
    padding: 18px;
    color: #7a8491;
    background: #fafbfc;
}
</style>
